import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupValidator } from '@lib/yup-validator';
import { Button, Input, Text, TextArea, Modal } from '@atoms/index';
import { sendKnowMoreMessage } from '@services/message.service';
import { getAuth } from '@services/identity.service';
import moment from 'moment';

const ShowInterestFormModal = ({
    show,
    onClose,
    setShowInterestForm,
    setShowSuccessMessage,
    setShownInterest,
    dealName,
    slug,
    opportunityId,
}) => {
    const [message, setMessage] = useState('');
    const [error, setError] = useState(false);
    const [currentUser, setCurrentUser] = useState({});
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        resolver: yupValidator(
            yup.object().shape({
                email: yup.string().email('Provide a valid Email ID'),
                name: yup.string().required('Plese enter your name'),
                message: yup.string().required('Please enter message'),
            })
        ),
    });
    const auth = getAuth();

    useEffect(() => {
        setCurrentUser(auth);
        reset({
            name: auth.name,
            email: auth.email,
            message: 'I would like to understand more about this opportunity.',
        });
    }, []);
    const onSubmit = async (data) => {
        const finalData = Object.assign({
            ...data,
            entityId: currentUser.id,
            opportunityId: opportunityId,
            mobile: currentUser.mobile,
            dateOfEnquiry: moment().format('DD-MM-YYYY'),
            dealName: dealName,
            type: 'shownInterest',
            slug: slug,
        });
        const response = await sendKnowMoreMessage(finalData);
        if (response.status) {
            setMessage('Successfully sent the message.');
            reset();
            setShowInterestForm(false);
            setShowSuccessMessage(true);
            setShownInterest(true);
        } else {
            setError(true);
            setMessage(response.message);
        }
    };
    return (
        <Modal
            show={show}
            onClose={onClose}
            width="md:w-140 sm:w-1/2 max-w-screen-lg"
            height="h-138"
            mainWrapperClassName="!p-2"
            label={'Opportunity Coming Soon'}
            labelPadding="p-3"
            labelSize="text-lg md:text-xl"
            className="!px-4 !pt-2"
            children={
                <div>
                    <Text
                        content={dealName}
                        className="mb-1 p4-bold"
                    />
                    <Text
                        content="This opportunity is coming soon! Drop us a note we'll send you more details about it."
                        className="mb-2 p4-regular"
                    />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="mt-2">
                            <Input
                                register={register}
                                className="p4-regular"
                                label={'Name'}
                                id="name"
                                type="text"
                                placeholder="Enter Your Name"
                                error={errors.name}
                            />
                        </div>
                        <div className="mt-2">
                            <Input
                                register={register}
                                className="p4-regular"
                                label={'Email'}
                                id="email"
                                type="email"
                                placeholder="Enter Your Email"
                                error={errors.email}
                            />
                        </div>
                        <div className="mt-2">
                            <TextArea
                                register={register}
                                className="p4-regular"
                                height='!h-20 md:!h-24'
                                label={'Message'}
                                id="message"
                                type="message"
                                placeholder="Enter Your Message"
                                error={errors.message}
                            />
                        </div>
                        <div className="text-center">
                            <Button
                                id="showInterestFormModalSubmitButton"
                                buttonType="submit"
                                design="standard"
                                type="primary"
                                className="justify-center w-full p-3 text-center text-basicBlack md:p-4 "
                                icon="yes"
                                gtmTag='gtm-click-im-interested-submit-btn'
                                children={
                                    <Text
                                        content={`Submit`}
                                        className="p4-semibold"
                                    />
                                }
                            />
                        </div>
                    </form>
                </div>
            }
        />
    );
};

export default ShowInterestFormModal;
